<template>
  <div class="FieldMetaDescription">
    <Field
      :label="$t('description')"
      :maxlength="255"
      :minlength="1"
      type="textarea"
      :value.sync="article.description">
      <FieldBtn
        class="light"
        :isLoading="isGeneratingArticleDescription"
        @click="generateDescription">
        {{ $t("generateDescription") }}
      </FieldBtn>
    </Field>
    <div
      class="descriptionLength"
      :class="{ danger: article.description && article.description.length > 160 }">
      {{
        $t("recommendedDescriptionLength", [
          article.description && article.description.length || 0,
        ])
      }}
    </div>
  </div>
</template>

<script>
import Message from '@mixins/Message'
import { actions } from '@utils'

export default {
  mixins: [Message],
  props: {
    article: Object,
  },
  data() {
    return {
      isGeneratingArticleDescription: false,
    }
  },
  methods: {
    async generateDescription() {
      const { variants } = await this.$wrap(
        this.CREATE_COMPLETION({
          type: 'GENERATE',
          promptTemplateName: 'ARTICLE_DESCRIPTION',
          category: this.article.category,
          articleId: this.article.id,
          fields: {
            category: this.article.category,
            topic: this.article.topic,
          },
        }),
        'isGeneratingArticleDescription',
        this.$t('articleDescriptionGenerated'),
      )
      this.article.description = variants[0].text
    },
    ...actions('CREATE_COMPLETION'),
  },
}
</script>

<style lang="scss">
.FieldMetaDescription {
  margin-bottom: 1rem;
  position: relative;
  width: 100%;

  .descriptionLength {
    color: $text-color-mid;
    display: flex;
    font-size: $h6;
    font-weight: $semibold;
    justify-content: flex-end;
    margin-left: $grid-unit-half;

    &.danger {
      color: $danger;
    }
  }

  .Field-cont {
    margin: 0;
  }
}
</style>
<i18n>

{
  "en": {
    "articleDescriptionGenerated": "Article description generated",
    "description": "Description",
    "generateDescription": "Generate description",
    "recommendedDescriptionLength": "{0} out of 160 max recommended characters"
  }
}
</i18n>
